import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../QueryKeys'
import { tasksService } from '../../tasksService'

export const useTaskTemplateDetails = (id?: number) => {
    const enabled = typeof id === 'number' && Number.isFinite(id)
    return useQuery({
        queryKey: [QUERY_KEYS.tasks.templates.TASK_TEMPLATES_DETAILS, id],
        queryFn: () => tasksService.getTaskTemplateDetails(id!),
        enabled,
        placeholderData: enabled ? keepPreviousData : undefined,
    })
}
